import { Component, inject } from '@angular/core';
import { ActionResult } from '@ntap/core';
import { EMPTY, Observable, map, switchMap } from 'rxjs';
import { ItemsListActionComponent } from '../items-list-action/items-list-action.component';
import { CommonConfirmActionService } from '@app/services/common-confirm-action.service';
import {
  calculateDisabledStateAndTooltipForSelectedJedinice,
  isDisabledActionForNerazvrstano
} from '@app/shared/util/jedinica-gradiva-security-utils';
import { withTooltipState } from '@app/shared/mixins/with-tooltip-state.mixin';

@Component({
  selector: 'app-publish-unpublish-jedinice-action',
  templateUrl: '../common-confirm-action-template.html'
})
export class PublishUnpublishJediniceActionComponent extends withTooltipState(
  ItemsListActionComponent
) {
  key: string = 'publishUnpublish' + this.toString;

  public commonConfirmActionService = inject(CommonConfirmActionService);

  public override doExecute(): Observable<ActionResult> {
    return this.commonConfirmActionService.confirm(this.key).pipe(
      switchMap(({ confirmed, addPodjedinice }) => {
        if (confirmed) {
          return super.doExecuteWithParams({
            $addPodjedinice: addPodjedinice
          });
        }
        return EMPTY;
      })
    );
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedItems) => {
        const isDisabledBecauseSystem =
          isDisabledActionForNerazvrstano(selectedItems);
        const [publishable, tooltip] =
          calculateDisabledStateAndTooltipForSelectedJedinice(selectedItems);

        if (!publishable) {
          this.setTooltip(tooltip);
        } else if (isDisabledBecauseSystem) {
          this.setTooltip('Granu nerazvrstanog gradiva nije moguće objaviti.');
        } else {
          this.setTooltip(this.action.description);
        }

        return (
          selectedItems.length <= 0 || !publishable || isDisabledBecauseSystem
        );
      })
    );
  }
}
